import { createFormItem } from "@/component-create/utils/create-form-item"
import { SearchForm } from "@/component-create/SearchForm"
import { FORM_ITEM } from "@/components/form/enums"

export function searchForm(el: Element) {
  const searchForm = new SearchForm(el, items, { labelWidth: '80px' })
  return searchForm
}

const items = [
  createFormItem('岗位名称', 'postName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  createFormItem('岗位编码', 'postCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
]